import {PropertyType} from 'common/report/constants';
import {
  BooleanOperator,
  ListOperator,
  NumberOperator,
  StringOperator,
} from 'common/widgets/property-filter-menu/models/types';

/**
 * These map to components with prefix "cohorts-builder-", ie, for BuilderType.Date
 * there is a corresponding "cohorts-builder-time"
 */
export enum ConditionType {
  Cohorts = `cohorts`,
  Events = `events`,
  People = `users`,
}

export enum ConditionTab {
  All = `all`,
  Cohorts = `cohorts`,
  DataGroup = `datagroup`,
  Events = `events`,
  People = `users`,
}

export enum DateRangeType {
  Between = `between`,
  On = `on`,
  Relative = `in the last`,
  Since = `since`,
  RelativeFuture = `in the next`,
  RelativeBeforeInPast = `more than`,
}

export const Type = PropertyType;
export type Type = PropertyType;

export {StringOperator, ListOperator, NumberOperator, BooleanOperator};

export enum DatetimeOperator {
  After = `after`,
  Between = `between`,
  On = `on`,
  Relative = `in the last`,
  RelativeFuture = `in the next`,
  RelativeBeforeInPast = `more than`,
}

export enum FrequencyOperator {
  AtLeast = `at least`,
  Between = `between`,
  EqualTo = `equal to`,
  GreaterThan = `greater than`,
  LessThan = `less than`,
}
